import styles from './NotifyInternetRecommender.module.scss';
import { NotifyForm, NotifySuccess } from '../../components';
import { STEPS } from '../../InternetRecommender.config';
import { emailRegex } from '../../../../utils';
import { useAjax, useLocalStorage, useTracking } from '../../../../hooks';
import React, { useState } from 'react';
import { Card } from '@wienenergiegithub/ui-next';
import { useFormStore } from '@ariakit/react';
import PropTypes from 'prop-types';

const NotifyInternetRecommender = ({ bauvorhabenSite }) => {
  const [address] = useLocalStorage('address-check');
  const track = useTracking();
  const [step, setStep] = useState(STEPS.NOTIFY_AVAILABILITY);
  const [values, setValues] = useState({
    gender: 'frau',
    firstname: '',
    lastname: '',
    email: '',
  });
  const form = useFormStore({ values, setValues });
  const [submitShowInterest] = useAjax('we_theme_superschnell_show_interest');

  form.useValidate(() => {
    if (!values.gender) {
      form.setError('gender', 'Bitte Anrede angeben');
    }

    if (!values.firstname) {
      form.setError('firstname', 'Bitte Vorname angeben');
    }

    if (!values.lastname) {
      form.setError('lastname', 'Bitte Nachname angeben');
    }

    if (!values.email) {
      form.setError('email', 'Bitte Email Adresse angeben');
    } else if (!emailRegex.test(values.email.trim().toLowerCase())) {
      form.setError('email', 'Bitte gültige Email Adresse angeben');
    }
  });

  form.useSubmit(async () => {
    const postValues = {
      ...values,
      ...address,
    };

    track({
      event: 'superschnell_interesse-abgeschickt',
      title: 'Superschnell Interesse abgeschickt',
      options: {
        zipcode: address?.plzOrt?.split(' ')[0],
      },
    });

    try {
      await submitShowInterest(postValues);
      setStep(STEPS.SUCCESS_NOTIFY_AVAILABILITY);
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      throw { street: 'Adresse konnte nicht gefunden werden.' };
    }
  });

  return (
    <Card className={styles.container}>
      {step === STEPS.NOTIFY_AVAILABILITY && <NotifyForm store={form} />}
      {step === STEPS.SUCCESS_NOTIFY_AVAILABILITY && (
        <NotifySuccess bauvorhabenSite={bauvorhabenSite} />
      )}
    </Card>
  );
};

NotifyInternetRecommender.propTypes = {
  bauvorhabenSite: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
};

export { NotifyInternetRecommender };
